<template>
  <div class="lang-switcher" :title="$t('nav.language')">
    <button
      v-for="loc in locales"
      :key="loc.code"
      type="button"
      class="lang-btn"
      :class="{ active: currentLocale === loc.code }"
      @click="pick(loc.code)"
    >{{ loc.code.toUpperCase() }}</button>
  </div>
</template>

<script>
/* eslint-disable */
import { AVAILABLE_LOCALES, setLocale } from "@/i18n";
import { useI18n } from "vue-i18n";

export default {
  name: "LanguageSwitcher",
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  data() {
    return {
      locales: AVAILABLE_LOCALES,
    };
  },
  computed: {
    currentLocale() { return this.locale; },
  },
  methods: {
    pick(code) {
      if (code === this.locale) return;
      setLocale(code);
    },
  },
};
</script>

<style scoped>
.lang-switcher {
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  border: 1px solid #d0d7de;
  border-radius: 999px;
  background: #fff;
}
.lang-btn {
  border: 0;
  background: transparent;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #57606a;
  cursor: pointer;
  line-height: 1;
  letter-spacing: 0.5px;
}
.lang-btn:hover { color: #24292f; }
.lang-btn.active {
  background: #1f6feb;
  color: #fff;
}
</style>
